import { Component } from '@angular/core';

@Component({
  selector: 'app-driver-payout-complete',
  template: `
    <div class="dp-page">
      <img src="assets/images/logo.png" alt="DarkCarz" class="dp-logo">
      <h1>Payout setup received</h1>
      <p>Thanks — Stripe has your information. You can close this window.</p>
    </div>
  `,
  styles: [`
    .dp-page {
      min-height: 100vh;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 2rem;
      text-align: center;
      font-family: 'SlateStd-Bk', 'Lucida Grande', Helvetica, Arial, sans-serif;
      background: #111;
      color: #f3f4f6;
    }
    .dp-logo { width: 120px; margin-bottom: 1.5rem; }
    h1 { font-size: 1.5rem; margin: 0 0 0.75rem; font-weight: 600; }
    p { margin: 0; max-width: 28rem; color: #9ca3af; line-height: 1.5; }
  `]
})
export class DriverPayoutCompleteComponent {}
